module.exports = __webpack_public_path__ + "static/media/setting-active.f22a9ba6.svg";